<template>
  <Teleport to="body">
    <!-- eslint-disable -->
    <div class="wvLoading" style="display: none;">
      <div class="wvLoadingCnt">
        <p class="wvLoading__image">
          <img src="~/assets/images/Te/TeBotchan/botchan_logo.png" alt="" class="wvLoading_img">
        </p>
        <p class="wvLoading__text">ページにアクセス中です。</p>
      </div>
    </div>
  </Teleport>
</template>

<script>
/* eslint-disable */
function fadeOut(node, duration) {
  node.style.opacity = 1;
  var start = performance.now();
  requestAnimationFrame(function tick(timestamp) {
    var easing = (timestamp - start) / duration;
    node.style.opacity = Math.max(1 - easing, 0);
    if (easing < 1) {
      requestAnimationFrame(tick);
    } else {
      node.style.opacity = '';
      node.style.display = 'none';
      node.classList.add('wvLoading--fadeOut');
    }
  });
}
function wvFadeOut() {
  const t = document.querySelector('.wvLoading');
  if (!t.classList.contains('wvLoading--fadeOut')) {
    let fadeLoading = setTimeout(function () {
      fadeOut(t, 650);
      clearTimeout(fadeLoading);
    }, 1200);
  }
}

// パラメータのセットを配列で管理
const paramSets = [
  {
    params: {
      utm_source: 'felmat',
      utm_medium: 'affiliate',
      utm_campaign: 'winut'
    }
  },
  {
    params: {
      utm_source: 'ceoclone',
      utm_medium: 'ceoclone',
      utm_campaign: 'ceoclone',
      utm_id: 'ceoclone'
    }
  }
];

function getQueryParams() {
  return Object.fromEntries(new URLSearchParams(window?.location?.search));
}

function checkParams(params, set) {
  return Object.keys(set).every(key => params[key] === set[key]);
}

// URLパラメータを取得
const params = getQueryParams();

// パラメータのセットをチェック
paramSets.forEach(set => {
  if (checkParams(params, set.params)) {
    const wvLoading = document.querySelector('.wvLoading').removeAttribute('style');
    document.addEventListener('efo_loaded_ready', function () {
      btag('event', 'open');
    });
    document.addEventListener('efo_opened_event', function () {
      wvFadeOut();
    });
    window.addEventListener('load', function () {
      setTimeout(wvFadeOut, 5000);
    });
  }
});
</script>

<style>
.wvLoading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  text-align: center;
}

.wvLoadingCnt {
  padding-left: 3.2vw;
  padding-right: 3.2vw;
}

.wvLoading__image {
  width: min(70vw, 400px);
  margin: auto;
  text-align: center;
}

.wvLoading_img {
  max-width: 100%;
  width: auto;
  height: auto;
}

.wvLoading__text {
  font-size: clamp(1.2rem, 2.4vw, 1.6rem);
  margin-block-start: 2rem;
  text-align: center;
}
</style>
